import React, { Component } from 'react';
import { View, Text, Button } from 'react-native';
import { Link } from 'react-router-dom';

import { auth, provider } from '../../configs/firebase';

export default class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            user: null
        }
        this.login = this.login.bind(this);
        this.logout = this.logout.bind(this);
    }


    login() {
        auth.signInWithPopup(provider)
            .then((result) => {
                const user = result.user;
                this.setState({
                    user
                });
            });
    }

    logout() {
        auth.signOut()
            .then(() => {
                this.setState({
                    user: null
                });
            });
    }

    componentWillMount() {
        auth.onAuthStateChanged((user) => {
            if (user) {
                this.setState({ user });
            }
        });
    }

    render() {
        return (
            <View style={{ paddingTop: 0, padding: '5%', justifyContent: 'center', alignItems: 'center' }}>

                <View style={{ width: '80%', backgroundColor: '#264380', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center', padding: '10px' }}>
                    <Link to="/"><Text style={{ color: '#ffffff', fontWeight: '600' }}>FactPoint Admin</Text></Link>
                    {this.state.user ? <Button title="Sign-out" onPress={this.logout} /> : <Button title="Sign-in" onPress={this.login} />}
                </View>
                <View style={{ borderColor: '#b2b4b7', borderWidth: 1, height: '100%', width: '80%' }}>
                    {this.state.user ? this.props.children : <Text>You are not authorized to see this content</Text>}
                </View>
            </View>
        )
    }
}
